import { connect } from 'react-redux';

import CartPage, { StateProps } from 'components/pages/accessories/cart/CartPage';
import { IRootState } from 'redux/root_reducer';

import Shopify from 'providers/shopify';

const maptStateToProps = ({ shopify, display }: IRootState): StateProps => {
    if (!shopify.hasLoaded) return { baseUrl: '', cart: [], isLoading: true, totalPrice: 0, isMobile: display.isMobile };

    return {
        baseUrl: shopify.url,
        cart: shopify.cartItems,
        isLoading: false,
        isMobile: display.isMobile,
        totalPrice: Shopify.calculateCartTotal(shopify.products, shopify.cartItems)
    };
};

export default connect(maptStateToProps)(CartPage);



// WEBPACK FOOTER //
// ./src/containers/pages/accessories/cart/CartPage.tsx